export default host => clientId => `${host}/clients/${clientId}/contentCreators/backup`